import PropTypes from "prop-types";
import React, {useState} from "react";
import { Col, Row, Container } from 'react-bootstrap';
import { Link } from "@StarberryUtils";
import "../managing/managing.scss";
import DotsImg from "../../../images/dots-img.svg"
import ContactForm from "../../ContactForm/ContactForm";
import ReactMarkdown from "react-markdown"
import { getSrc } from "gatsby-plugin-image"
 

// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 0.4,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}


const Managing = (props, { siteTitle }) => {

  const img = '<h2 class="sec-title"><em class="dots-img d-none d-lg-inline"><img loading="lazy" class="shadow-img" src=' + DotsImg + ' alt="dots"/></em>'
  const [openContactForm, setOpenContactForm] = useState(false);
  return (
    <>
      <section className="managing-sec components-Home-managing-managing">
        <Container>
          <Row>
            <Col lg={4} className="textingCon">
              <div variants={titleVariants}>

                {props.Title ? <ReactMarkdown source={props.Title.replace("<h2>", img)} allowDangerousHtml /> : ''}
                {props.CTA_Label && props.CTA_Link && props.CTA_Position == "left" &&
                  <>
                    {props.CTA_Link && props.CTA_Link.includes('contact_modal') ?
                      <button className="btn d-none d-lg-inline-block" onClick={() => setOpenContactForm(true)}>{props.CTA_Label}</button>
                      :
                      <Link to={`/${props.CTA_Link}`} class="btn d-none d-lg-inline-block">{props.CTA_Label}</Link>
                    }

                  </>
                }
              </div>

            </Col>
            <Col lg={8} /**className="textContact animate__animated"*/ >

              <div variants={contentVariants}>
                {props.Content ? <ReactMarkdown source={props.Content} allowDangerousHtml className="editor" /> : ''}
                {props.CTA_Label && props.CTA_Link && props.CTA_Position == "right" &&
                  <>
                    {props.CTA_Link && props.CTA_Link.includes('contact_modal') ?
                      <button className="btn" onClick={() => setOpenContactForm(true)}>{props.CTA_Label}</button>
                      :
                      <Link to={`/${props.CTA_Link}`} class="btn d-none d-lg-inline-block">{props.CTA_Label}</Link>
                    } 

                  </>
                }
                {props.CTA_Label && props.CTA_Link && props.CTA_Position == "left" &&
                  <>
                    {props.CTA_Link && props.CTA_Link.includes('contact_modal') ?
                      <button className="btn d-block d-lg-none" onClick={() => setOpenContactForm(true)}>{props.CTA_Label}</button>
                      :
                      <Link to={`/${props.CTA_Link}`} class="btn d-block d-lg-none">{props.CTA_Label}</Link>
                    }

                  </>
                }

                {props.People ?
                  <>
                    {props.People.Signature_Image ?
                      <div className="signature"><img loading="lazy" className="banner-img" src={props.People.Signature_Image.publicURL} alt={`${props.People.Name} Signature - Martyn Gerrard`} /></div> : ''}

                    <div className="user-profile d-flex align-items-center justify-content-between">
                      <span className="profile-img"><img loading="lazy" className="banner-img" src={getSrc(props.People.Tile_Image)} alt={`${props.People.Name} - Martyn Gerrard`} /></span>
                      <div className="profile-info">
                        <strong className="d-block">{props.People.Name}</strong>
                        <span className="d-block">{props.People.Designation}</span>
                      </div>
                    </div></> : ''}


              </div>
            </Col>
          </Row>
        </Container>
        <ContactForm openForm={openContactForm} setOpenForm={setOpenContactForm} />
      </section>
    </>
  )
}

Managing.propTypes = {
  siteTitle: PropTypes.string,
}

Managing.defaultProps = {
  siteTitle: ``,
}

export default Managing
